

import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { AiOutlineFile } from 'react-icons/ai';      // Booking Summary icon
import { MdLocationOn } from 'react-icons/md';       // Track Location icon
import { FaCar } from 'react-icons/fa';              // Vehicle DOC icon
import BookingSummary from './BookingSummary';
import TrackLocation from './TrackLocation';
import VehicalDoc from './VehicleDOC';
import { BiChevronLeft } from 'react-icons/bi';

const RideDetails = () => {
    const [value, setValue] = useState(0); // State to track the selected tab

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="flex justify-center  min-h-screen border rounded-lg bg-gray-100 w-full">
            <div className="w-full bg-white rounded-lg  p-6">

                {/* <div className="text-[#FF9630] font-semibold text-lg mb-4 text-left">My Ride</div> */}
                <div className="text-[#FF9630] font-semibold text-lg mb-4 flex items-center">
                    <BiChevronLeft size={24} className="mr-1" /> My Ride
                </div>

                {/* Tabs Section */}
                <Box sx={{ width: '100%' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="ride details tabs"
                        TabIndicatorProps={{
                            style: { display: 'none' } // Hide the default tab indicator
                        }}
                    >
                        <Tab
                            label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <AiOutlineFile size={20} style={{ marginRight: 8 }} />
                                    Booking Summary
                                </div>
                            }
                            sx={{
                                backgroundColor: value === 0 ? '#FAB12F' : 'transparent',
                                color: value === 0 ? '#fff' : '#2c2c2c',
                                border: value !== 0 ? '1px solid #d0d0d0' : 'none',
                                borderRadius: '8px',
                                minWidth: '150px',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                mr: 1,
                                '&:hover': {
                                    backgroundColor: value === 0 ? '#FAB12F' : '#f5f5f5',
                                },
                            }}
                        />
                        <Tab
                            label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <MdLocationOn size={20} style={{ marginRight: 8 }} />
                                    Track Location
                                </div>
                            }
                            sx={{
                                backgroundColor: value === 1 ? '#FAB12F' : 'transparent',
                                color: value === 1 ? '#fff' : '#2c2c2c',
                                border: value !== 1 ? '1px solid #d0d0d0' : 'none',
                                borderRadius: '8px',
                                minWidth: '150px',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                mr: 1,
                                '&:hover': {
                                    backgroundColor: value === 1 ? '##FAB12F' : '#f5f5f5',
                                },
                            }}
                        />
                        <Tab
                            label={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <FaCar size={20} style={{ marginRight: 8 }} />
                                    Vehicle DOC
                                </div>
                            }
                            sx={{
                                backgroundColor: value === 2 ? '#FAB12F' : 'transparent',
                                color: value === 2 ? '#fff' : '#2c2c2c',
                                border: value !== 2 ? '1px solid #d0d0d0' : 'none',
                                borderRadius: '8px',
                                minWidth: '150px',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                '&:hover': {
                                    backgroundColor: value === 2 ? '#FAB12F' : '#f5f5f5',


                                },
                            }}
                        />
                    </Tabs>
                </Box>

                {/* Tab Content Section */}
                <Box sx={{ paddingTop: '20px' }}>
                    {value === 0 && <BookingSummary />}
                    {value === 1 && <TrackLocation />}
                    {value === 2 && <VehicalDoc />}
                </Box>
            </div>
        </div>
    );
};

export default RideDetails;
